<template>
  <div id="salesmanList" v-loading="exportLoading">
    <el-card>
      <!-- 查询选项 -->
      <Form class="salesmanForm" :label-width="160">
        <FormItem class="form_item" :label="$t('projectName1')">
          <Input clearable v-model="projectName" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('projectNumber1')">
          <Input clearable v-model="projectNumber" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('serviceContractNo2')">
          <Input clearable v-model="serviceContractNo" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('taskName1')">
          <Input clearable v-model="taskName" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('taskNumber1')">
          <Input clearable v-model="taskNumber" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('taskOwner1')">
          <el-select v-model="taskOwner" clearable filterable remote :remote-method="value => remoteMethod('TaskOwnerList', value)">
            <el-option v-for="(item, index) in TaskOwnerList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
          </el-select>
        </FormItem>
        <FormItem class="form_item" :label="$t('taskType1')" v-if="queryShow">
          <el-select v-model="taskType" clearable >
            <el-option v-for="item in TaskTypeList" :key="item.sysDesc" :label="item.sysValue" :value="item.sysDesc"></el-option>
          </el-select>
        </FormItem>
        <FormItem class="form_item" :label="$t('taskStatus1')" v-if="queryShow">
          <el-select v-model="taskStatus" clearable>
            <el-option v-for="item in StatusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </FormItem>
        <FormItem class="form_item" :label="$t('serviceBom1')" v-if="queryShow">
          <el-select v-model="serviceBom" clearable filterable remote :remote-method="remoteBom" v-el-select-loadmore="loadMore(rangeNumber)">
            <el-option v-for="(item, index) in ServiceBomList.slice(0, rangeNumber)" :key="index" :label="item.serviceBom" :value="item.serviceBom"></el-option>
          </el-select>
        </FormItem>
        <FormItem class="form_item" :label="$t('country1')" v-if="queryShow">
          <el-select filterable v-model="country" clearable>
            <el-option v-for="item in CountryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
          </el-select>
        </FormItem>
        <FormItem class="form_item" :label="$t('deliveryArea1')" v-if="queryShow">
          <Input clearable v-model="deliveryArea" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('taskStartDate1')" v-if="queryShow">
          <el-date-picker v-model="taskStartDate" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('selectdate')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('taskEndDate1')" v-if="queryShow">
          <el-date-picker v-model="taskEndDate" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('selectdate')"/>
        </FormItem>
        <div class="buttonDiv">
          <el-button type="primary" size="mini" @click="advancedFilter">{{$t('advancedFilter')}}</el-button>
          <el-button type="primary" size="mini" icon="el-icon-search" @click="searchTaskByPage" :loading="searchLoading">{{$t('search')}}</el-button>
          <el-button v-has="{class:'taskExport'}" type="primary" size="mini" icon="el-icon-download" @click="exportExcel">{{$t('export')}}</el-button>
          <el-button v-has="{class:'taskAdd'}" type="primary" size="mini" icon="el-icon-plus" @click="addInfo">{{$t('add')}}</el-button>
        </div>
      </Form>
      <div class="contentTableDiv">
        <el-table :data="tableData" @selection-change="handleSelectionChange" border style="width:100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="id" v-if="false"></el-table-column> 
          <!-- <el-table-column prop="taskNumber" :label="$t('taskNumber')" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <a style="color:blue;" @click="handleNavigation(scope.row)">{{scope.row.taskNumber}}</a>
            </template>
          </el-table-column> -->
          <el-table-column prop="taskName" :label="$t('taskName')" align="left" :show-overflow-tooltip="true" min-width="350">
            <template slot-scope="scope">
              <a style="color:blue;" @click="handleNavigation(scope.row)">{{scope.row.taskName}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="taskType" :label="$t('taskType')" align="center" :show-overflow-tooltip="true" min-width="200"></el-table-column>
          <el-table-column prop="taskStatus" :label="$t('taskStatus')" align="center" :show-overflow-tooltip="true" min-width="150"></el-table-column>
          <el-table-column prop="taskOwner" :label="$t('taskOwner')" align="center" min-width="160"></el-table-column>
          <el-table-column prop="projectName" :label="$t('projectName')" align="left" :show-overflow-tooltip="true" min-width="150">
            <template slot-scope="scope">
              <a style="color:blue;" @click="handleProject(scope.row)">{{scope.row.projectName}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="subtaskNum" :label="$t('subtaskNum')" align="center" min-width="120">
            <template slot-scope="scope">
              <a style="color:blue;" @click="handleSubtask(scope.row)">{{scope.row.subtaskNum}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="labourSum" :label="$t('labourSum')" align="center" :show-overflow-tooltip="true" min-width="140">
            <template slot-scope="scope">
              <a style="color:blue;" @click="handleLabour(scope.row)">{{scope.row.labourSum}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="taskStartDate" :label="$t('taskStartDate')" width="160" align="center"></el-table-column>
          <el-table-column prop="taskEndDate" :label="$t('taskEndDate')" width="160" align="center"></el-table-column>
          <el-table-column :label="$t('operate')" fixed="right" width="130" align="center">
            <template slot-scope="scope">
              <el-dropdown trigger="click" v-if="scope.row.flagStatus!='1'&&scope.row.flagStatus!='3'">
                <el-button size="mini" type="primary">{{$t('operate')}}<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item><el-button v-has="{class:'taskSub'}" v-if="scope.row.flagStatus=='0'" size="mini" type="primary" @click="addSubtask(scope.row)">{{$t('addSubtask')}}</el-button></el-dropdown-item>
                  <el-dropdown-item><el-button v-has="{class:'taskUpdate'}" v-if="scope.row.flagStatus=='0' || scope.row.taskType === 'Pre-sales Test'" size="mini" type="primary" @click="handleEdit(scope.row)">{{$t('update')}}</el-button></el-dropdown-item>
                  <el-dropdown-item><el-button v-has="{class:'taskFreeze'}" v-if="scope.row.flagStatus=='0'" size="mini" type="danger" @click="handleFreeze(scope.row)">{{$t('freeze')}}</el-button></el-dropdown-item>
                  <!-- <el-dropdown-item><el-button v-has="{class:'taskDelete'}" v-if="scope.row.labourSum==0" size="mini" type="danger" @click="handleDelete(scope.row)">{{$t('delete')}}</el-button></el-dropdown-item> -->
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table> 
      </div>
      <div class="pageDiv">
        <el-pagination small @size-change="changePageSize" @current-change="changePage" :current-page="currentPage" :page-sizes="[10, 20,50,100]"
          :page-size="pageSize" layout="total, prev, pager, next, sizes, jumper" :total="totalCount">
        </el-pagination>
      </div>
    </el-card>
    <el-card>
      <el-collapse >
        <el-collapse-item name="1">
          <template slot="title"><span style="font-size: 18px;">Frozen/Closed Task List<i class="header-icon el-icon-caret-bottom"></i></span></template>
          <!-- 查询选项 -->
          <Form class="salesmanForm" :label-width="160">
            <FormItem class="form_item" :label="$t('projectName1')">
              <Input clearable v-model="frozenPaName" :placeholder="$t('enter')"/>
            </FormItem>
            <FormItem class="form_item" :label="$t('projectNumber1')">
              <Input clearable v-model="frozenPaNumber" :placeholder="$t('enter')"/>
            </FormItem>
            <FormItem class="form_item" :label="$t('serviceContractNo2')">
              <Input clearable v-model="frozenContractNo" :placeholder="$t('enter')"/>
            </FormItem>
            <FormItem class="form_item" :label="$t('taskName1')">
              <Input clearable v-model="frozenTaName" :placeholder="$t('enter')"/>
            </FormItem>
            <FormItem class="form_item" :label="$t('taskNumber1')">
              <Input clearable v-model="frozenTaNumber" :placeholder="$t('enter')"/>
            </FormItem>
            <FormItem class="form_item" :label="$t('taskOwner1')">
              <el-select v-model="frozenTaOwner" clearable filterable remote :remote-method="value => remoteMethod('FrozenUserList', value)">
                <el-option v-for="(item, index) in FrozenUserList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
              </el-select>
            </FormItem>
            <FormItem class="form_item" :label="$t('taskType1')" v-if="filterShow">
              <el-select v-model="frozenTaType" clearable >
                <el-option v-for="item in TaskTypeList" :key="item.sysDesc" :label="item.sysValue" :value="item.sysDesc"></el-option>
              </el-select>
            </FormItem>
            <FormItem class="form_item" :label="$t('taskStatus1')" v-if="filterShow">
              <el-select v-model="frozenTaStatus" clearable>
                <el-option v-for="item in FrozenStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </FormItem>
            <FormItem class="form_item" :label="$t('serviceBom1')" v-if="filterShow">
              <el-select v-model="frozenSvBom" clearable filterable remote :remote-method="remoteFrozenBom" v-el-select-loadmore="loadMore(rangeNumber)">
                <el-option v-for="(item, index) in FrozenBomList.slice(0, rangeNumber)" :key="index" :label="item.serviceBom" :value="item.serviceBom"></el-option>
              </el-select>
            </FormItem>
            <FormItem class="form_item" :label="$t('country1')" v-if="filterShow">
              <el-select filterable v-model="frozenCountry" clearable>
                <el-option v-for="item in CountryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
              </el-select>
            </FormItem>
            <FormItem class="form_item" :label="$t('deliveryArea1')" v-if="filterShow">
              <Input clearable v-model="frozenDeArea" :placeholder="$t('enter')"/>
            </FormItem>
            <FormItem class="form_item" :label="$t('taskStartDate1')" v-if="filterShow">
              <el-date-picker v-model="frozenTaStartDate" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('selectdate')"/>
            </FormItem>
            <FormItem class="form_item" :label="$t('taskEndDate1')" v-if="filterShow">
              <el-date-picker v-model="frozenTaEndDate" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('selectdate')"/>
            </FormItem>
            <div class="buttonDiv">
              <el-button type="primary" size="mini" @click="frozenFilter">{{$t('advancedFilter')}}</el-button>
              <el-button type="primary" size="mini"  @click="searchFrozenTaskList" :loading="searchFrozenLoading">{{$t('search')}}</el-button>
              <el-button v-has="{class:'taskExport'}" type="primary" size="mini" @click="frozenExcel">{{$t('export')}}</el-button>
            </div>
          </Form>
          <div class="contentTableDiv">
            <el-table :data="FrozenData" @selection-change="frozenSelectionChange" border style="width:100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
              <el-table-column type="selection" width="50"></el-table-column>
              <el-table-column prop="taskName" :label="$t('taskName')" align="left" :show-overflow-tooltip="true" min-width="350">
                <template slot-scope="scope">
                  <a style="color:blue;" @click="handleNavigation(scope.row)">{{scope.row.taskName}}</a>
                </template>
              </el-table-column>
              <el-table-column prop="taskType" :label="$t('taskType')" align="center" :show-overflow-tooltip="true" min-width="200"></el-table-column>
              <el-table-column prop="taskStatus" :label="$t('taskStatus')" align="center" :show-overflow-tooltip="true" min-width="150"></el-table-column>
              <el-table-column prop="taskOwner" :label="$t('taskOwner')" align="center" min-width="160"></el-table-column>
              <el-table-column prop="projectName" :label="$t('projectName')" align="left" :show-overflow-tooltip="true" min-width="150">
                <template slot-scope="scope">
                  <a style="color:blue;" @click="handleProject(scope.row)">{{scope.row.projectName}}</a>
                </template>
              </el-table-column>
              <el-table-column prop="subtaskNum" :label="$t('subtaskNum')" align="center" min-width="120">
                <template slot-scope="scope">
                  <a style="color:blue;" @click="handleSubtask(scope.row)">{{scope.row.subtaskNum}}</a>
                </template>
              </el-table-column>
              <el-table-column prop="labourSum" :label="$t('labourSum')" align="center" :show-overflow-tooltip="true" min-width="140">
                <template slot-scope="scope">
                  <a style="color:blue;" @click="handleLabour(scope.row)">{{scope.row.labourSum}}</a>
                </template>
              </el-table-column>
              <el-table-column prop="taskStartDate" :label="$t('taskStartDate')" width="160" align="center"></el-table-column>
              <el-table-column prop="taskEndDate" :label="$t('taskEndDate')" width="160" align="center"></el-table-column>
              <el-table-column :label="$t('operate')" fixed="right" width="110" align="center">
                <template slot-scope="scope">
                  <el-button v-has="{class:'taskUnfreeze'}" v-if="scope.row.flagStatus=='2'" size="mini" type="danger" @click="handleUnFreeze(scope.row)">{{$t('unFreeze')}}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pageDiv">
            <el-pagination small @size-change="changeFrozenPageSize" @current-change="changeFrozenPage" :current-page="currentFrozenPage" :page-sizes="[10, 20,50,100]"
              :page-size="pageFrozenSize" layout="total, prev, pager, next, sizes, jumper" :total="totalFrozenCount">
            </el-pagination>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>

    <Modal v-model="modelFreeze" :closable='true' :mask-closable='false' :title="$t('freezingReason')">
      <div slot="footer">
        <Button type="primary" size="small" @click="close">{{$t('cancle')}}</Button>
        <Button type="primary" size="small" @click="submitFreezeForm('freezeForm')">{{$t('confrim')}}</Button>
      </div>
      <el-form :model="freezeForm" ref="freezeForm" :rules="rules" >
          <el-row>
            <el-col :xs="24" :md="24">
              <el-form-item prop="freezingReason" >
                <el-input v-model="freezeForm.freezingReason" type="textarea" :rows="4" :placeholder="$t('reason')"/>
              </el-form-item>
            </el-col>
          </el-row>
      </el-form>
    </Modal>
    <Modal v-model="modelUnFreeze" :closable='true' :mask-closable='false' :title="$t('unFreezingReason')">
      <div slot="footer">
        <Button type="primary" size="small" @click="close">{{$t('cancle')}}</Button>
        <Button type="primary" size="small" @click="submitUnFreezeForm('unFreezeForm')">{{$t('confrim')}}</Button>
      </div>
      <el-form :model="unFreezeForm" ref="unFreezeForm" :rules="rules" >
          <el-row>
            <el-col :xs="24" :md="24">
              <el-form-item prop="unFreezingReason" >
                <el-input v-model="unFreezeForm.unFreezingReason" type="textarea" :rows="4" :placeholder="$t('reason')"/>
              </el-form-item>
            </el-col>
          </el-row>
      </el-form>
    </Modal>
  </div>
</template>
<script>
    import {_debounce} from '@/utils/selectAPI'
    import * as validate from '@/utils/validate'

    export default {
        name: 'task',
        activated () {
          let toTask = this.$route.params.toTask;
          if(toTask == 'N'){
            this.getTaskByPage();
          }
        },
        created () {
          // this.getParams();
          this.getTaskByPage();
          this.getCountry();
          this.getTaskTypeList();
          this.getServiceBomList();
          this.getFrozenTaskList();
        },
        data () {
          return {
            rangeNumber: 10,
            projectNumber:null,
            projectName:null,
            serviceContractNo:null,
            taskNumber:null,
            taskName:null,
            taskOwner:null,
            taskType:null,
            taskStatus:null,
            serviceBom:null,
            country:null,
            deliveryArea:null,
            taskStartDate:null,
            taskEndDate:null,
            //Frozen
            frozenPaName:null,
            frozenPaNumber:null,
            frozenContractNo:null,
            frozenTaName:null,
            frozenTaNumber:null,
            frozenTaOwner:null,
            frozenTaType:null,
            frozenTaStatus:null,
            frozenSvBom:null,
            frozenCountry:null,
            frozenDeArea:null,
            frozenTaStartDate:null,
            frozenTaEndDate:null,
            //other
            freezeForm:{
              freezingReason:null,
            },
            unFreezeForm:{
              unFreezingReason:null,
            },
            TaskTypeList:[],
            StatusList:[
              { value: 'ToDelivered',label: 'Waiting for Delivery'},
              { value: 'Delivered',label: 'Delivering'},
              { value: 'DeliveryCompleted',label: 'Fully Delivered'},
            ],
            FrozenStatus:[
              { value: 'Frozen',label: 'Frozen'},
              { value: 'Closed',label: 'Closed'},
            ],
            FrozenBomList:[],
            ServiceBomList:[],
            SBomList:[],
            CountryList:[],
            taskId:null,
            TSNumber:null,
            TSName:null,
            queryShow:false,
            filterShow:false,
            modelFreeze:false,
            modelUnFreeze:false,
            exportLoading:false,
            currentPage: 1,
            totalCount: 0,
            pageSize: 10,
            multipleSelection: [],
            frozenSelection: [],
            tableData: [],
            FrozenUserList:[],
            TaskOwnerList:[],
            FrozenData: [],
            currentFrozenPage: 1,
            totalFrozenCount: 0,
            pageFrozenSize: 10,
            rules: {
              freezingReason: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
              unFreezingReason: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
            },
            searchLoading: false,
            searchFrozenLoading: false,
          }
        },
        methods: {
          getParams(){
            let id = this.$route.params.id;
            if(id != undefined && id != null && id != ''){
              let params = this.$route.params;
              this.currentPage = params.currentPage;
              this.pageSize = params.pageSize;
              this.projectNumber = params.projectNumber;
              this.projectName = params.projectName;
              this.serviceContractNo = params.serviceContractNo;
              this.taskName = params.taskName;
              this.taskNumber = params.taskNumber;
              this.taskOwner = params.taskOwner;
              this.taskType = params.taskType;
              this.taskStatus = params.taskStatus;
              this.serviceBom = params.serviceBom;
              this.country = params.country;
              this.deliveryArea = params.deliveryArea;
              this.taskStartDate = params.taskStartDate;
              this.taskEndDate = params.taskEndDate;
            }
          },
          getCountry(){
            let url =`${this.$store.state.islhurl}keyValue/getSelectData`;
            let pm = {
              sysKey: 'Country',
              delFlg: '0',
            }
            this._post(url,pm).then(
              res => {   
                this.CountryList = res.data;
              }
            )
          },
          getTaskTypeList(){
            let url = `${this.$store.state.islhurl}keyValue/getSelectData`
            let pm = {
              sysKey: 'TaskType',
              delFlg: '0',
            }
            this._post(url,pm).then(
              res =>{
                this.TaskTypeList = res.data;
              }
            )
          },
          getServiceBomList(){
            let url =`${this.$store.state.islhurl}serviceBom/getSelectData`;
            this._post(url).then(
              res => {   
                this.SBomList = res.data;
                this.ServiceBomList = res.data;
                this.FrozenBomList = res.data;
              }
            )
          },
          getTaskByPage(){
            let projectId = this.$route.params.projectNumber;
            if(projectId != undefined && projectId != null && projectId != ''){
              this.projectNumber = projectId;
            }
            let url = `${this.$store.state.islhurl}getTaskInfo/${this.pageSize}/${this.currentPage}`
            let pm = {
              projectId: this.projectNumber==''?null:this.projectNumber,
              taskName: this.taskName==''?null:this.taskName,
              taskNumber: this.taskNumber==''?null:this.taskNumber,
              projectName: this.projectName==''?null:this.projectName,
              serviceContractNo: this.serviceContractNo==''?null:this.serviceContractNo,
              taskOwner: this.taskOwner==''?null:this.taskOwner,
              taskType: this.taskType==''?null:this.taskType,
              taskStatus: this.taskStatus==''?null:this.taskStatus,
              serviceBom: this.serviceBom==''?null:this.serviceBom,
              country: this.country==''?null:this.country,
              deliveryArea: this.deliveryArea==''?null:this.deliveryArea,
              taskStartDate: this.taskStartDate==''?null:this.taskStartDate,
              taskEndDate: this.taskEndDate==''?null:this.taskEndDate,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res =>{
                this.tableData =res.data;
                this.totalCount = res.totalNums;
              }
            )
          },
          searchTaskByPage(){
            this.pageSize = 10;
            this.currentPage = 1;
            let url = `${this.$store.state.islhurl}getTaskInfo/${this.pageSize}/${this.currentPage}`
            let pm = {
              projectId: this.projectNumber==''?null:this.projectNumber,
              taskName: this.taskName==''?null:this.taskName,
              taskNumber: this.taskNumber==''?null:this.taskNumber,
              projectName: this.projectName==''?null:this.projectName,
              serviceContractNo: this.serviceContractNo==''?null:this.serviceContractNo,
              taskOwner: this.taskOwner==''?null:this.taskOwner,
              taskType: this.taskType==''?null:this.taskType,
              taskStatus: this.taskStatus==''?null:this.taskStatus,
              serviceBom: this.serviceBom==''?null:this.serviceBom,
              country: this.country==''?null:this.country,
              deliveryArea: this.deliveryArea==''?null:this.deliveryArea,
              taskStartDate: this.taskStartDate==''?null:this.taskStartDate,
              taskEndDate: this.taskEndDate==''?null:this.taskEndDate,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this.searchLoading = true
            this._post(url,pm).then(
              res =>{
                this.tableData =res.data;
                this.totalCount = res.totalNums;
                this.searchLoading = false
              }
            ).catch(e => {
              this.searchLoading = false
            })
          },
          getFrozenTaskList(){
            let url = `${this.$store.state.islhurl}getFrozenTaskList/${this.pageFrozenSize}/${this.currentFrozenPage}`
            let pm = {
              projectId: this.frozenPaNumber==''?null:this.frozenPaNumber,
              projectName: this.frozenPaName==''?null:this.frozenPaName,
              serviceContractNo: this.frozenContractNo==''?null:this.frozenContractNo,
              taskName: this.frozenTaName==''?null:this.frozenTaName,
              taskNumber: this.frozenTaNumber==''?null:this.frozenTaNumber,
              taskOwner: this.frozenTaOwner==''?null:this.frozenTaOwner,
              taskType: this.frozenTaType==''?null:this.frozenTaType,
              taskStatus: this.frozenTaStatus==''?null:this.frozenTaStatus,
              serviceBom: this.frozenSvBom==''?null:this.frozenSvBom,
              country: this.frozenCountry==''?null:this.frozenCountry,
              deliveryArea: this.frozenDeArea==''?null:this.frozenDeArea,
              taskStartDate: this.frozenTaStartDate==''?null:this.frozenTaStartDate,
              taskEndDate: this.frozenTaEndDate==''?null:this.frozenTaEndDate,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res =>{
                this.FrozenData = res.data;
                this.totalFrozenCount = res.totalNums;
              }
            )
          },
          searchFrozenTaskList(){
            this.pageFrozenSize = 10;
            this.currentFrozenPage = 1;
            let url = `${this.$store.state.islhurl}getFrozenTaskList/${this.pageFrozenSize}/${this.currentFrozenPage}`
            let pm = {
              projectId: this.frozenPaNumber==''?null:this.frozenPaNumber,
              projectName: this.frozenPaName==''?null:this.frozenPaName,
              serviceContractNo: this.frozenContractNo==''?null:this.frozenContractNo,
              taskName: this.frozenTaName==''?null:this.frozenTaName,
              taskNumber: this.frozenTaNumber==''?null:this.frozenTaNumber,
              taskOwner: this.frozenTaOwner==''?null:this.frozenTaOwner,
              taskType: this.frozenTaType==''?null:this.frozenTaType,
              taskStatus: this.frozenTaStatus==''?null:this.frozenTaStatus,
              serviceBom: this.frozenSvBom==''?null:this.frozenSvBom,
              country: this.frozenCountry==''?null:this.frozenCountry,
              deliveryArea: this.frozenDeArea==''?null:this.frozenDeArea,
              taskStartDate: this.frozenTaStartDate==''?null:this.frozenTaStartDate,
              taskEndDate: this.frozenTaEndDate==''?null:this.frozenTaEndDate,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this.searchFrozenLoading = true
            this._post(url,pm).then(
              res =>{
                this.FrozenData = res.data;
                this.totalFrozenCount = res.totalNums;
                this.searchFrozenLoading = false
              }
            ).catch(e => {
              this.searchFrozenLoading = false
            })
          },
          addInfo() {
            this.$router.push({path:'/task/add'});
          },
          handleNavigation(index){
            let pm = {
              id: index.id,
              showRun:'Y',
            }
            this.$router.push({name:'task_detail',params:pm})
          },
          handleProject(index){
            let pm = {
              projectNumber: index.projectId,
            }
            this.$router.push({name:'project_detail',params:pm});
          },
          handleSubtask(index){
            let pm = {
              taskNumber: index.taskNumber,
              toSubtask: 'N',
            }
            this.$router.push({name:'subtask',params:pm});
            this.$store.commit('tagChange', 'subtask');
          },
          handleLabour(index){
            let pm = {
              taskNumber: index.taskNumber,
              toLabour: 'N',
            }
            this.$router.push({name:'labour',params:pm});
            this.$store.commit('tagChange', 'labour');
          },
          addSubtask(index) {
            let pm = {
              taskNumber: index.taskNumber,
            }
            this.$router.push({name:'subtask_add',params:pm})
          },
          handleEdit(index) {
            let pm = {
              id: index.id,
            }
            this.$router.push({name:'task_edit',params:pm})
          },
          handleFreeze(index){
            this.taskId = index.id;
            this.TSName = index.taskName;
            this.TSNumber = index.taskNumber;
            this.freezeForm.freezingReason = null;
            this.modelFreeze = true;
          },
          submitFreezeForm(formName){
            this.$refs[formName].validate((valid) => {
              if (valid) {
                this.freezeInfo();
              } else {
                return false;
              }
            });
          },
          freezeInfo(){
            let params = {
              id:this.taskId,
              taskName:this.TSName,
              taskNumber:this.TSNumber,
              freezingReason:this.freezeForm.freezingReason,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            let url = `${this.$store.state.islhurl}task/freezeInfo`
            this._post(url,params).then(
              res => {
                if(res=="200"){
                  this.getTaskByPage();
                  this.getFrozenTaskList();
                  this.modelFreeze = false;
                  this.$Message.success('Freeze successful' )
                }else{
                  this.$message.error(res);
                }
              }
            )
          },
          handleUnFreeze(index){
            this.taskId = index.id;
            this.TSNumber = index.taskNumber;
            this.unFreezeForm.unFreezingReason = null;
            this.modelUnFreeze = true;
          },
          submitUnFreezeForm(formName){
            this.$refs[formName].validate((valid) => {
              if (valid) {
                this.unFreezeInfo();
              } else {
                return false;
              }
            });
          },
          unFreezeInfo(){
            let params = {
              id:this.taskId,
              taskNumber:this.TSNumber,
              unfreezingReason:this.unFreezeForm.unFreezingReason,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            let url = `${this.$store.state.islhurl}task/unFreezeInfo`
            this._post(url,params).then(
              res => {
                if(res=="200"){
                  this.getTaskByPage();
                  this.getFrozenTaskList();
                  this.modelUnFreeze = false;
                  this.$Message.success('unFreeze successful' )
                }else{
                  this.$message.error(res);
                }
              }
            )
          },
          handleSelectionChange(val) {
            this.multipleSelection = val;
          },
          exportExcel(){
            this.exportLoading = true;
            let execlName = 'TaskInfo.xlsx';
            const length = this.multipleSelection.length;
            let ids = [];
            for (let i = 0; i < length; i++) {
              ids.push(this.multipleSelection[i].id)
            }
            this.$axios({
              url: `${this.$store.state.islhurl}task/exportInfo`,
              method: 'post',
              data: {
                ids: ids,
                projectId: this.projectNumber==''?null:this.projectNumber,
                taskName: this.taskName==''?null:this.taskName,
                taskNumber: this.taskNumber==''?null:this.taskNumber,
                projectName: this.projectName==''?null:this.projectName,
                serviceContractNo: this.serviceContractNo==''?null:this.serviceContractNo,
                taskOwner: this.taskOwner==''?null:this.taskOwner,
                taskType: this.taskType==''?null:this.taskType,
                taskStatus: this.taskStatus==''?null:this.taskStatus,
                serviceBom: this.serviceBom==''?null:this.serviceBom,
                country: this.country==''?null:this.country,
                deliveryArea: this.deliveryArea==''?null:this.deliveryArea,
                taskStartDate: this.taskStartDate==''?null:this.taskStartDate,
                taskEndDate: this.taskEndDate==''?null:this.taskEndDate,
                islhToken : sessionStorage.getItem('islhtoken'),
              },
              responseType:"blob"
            }).then(response=>{
              this.exportLoading = false;
              const blob = new Blob([response.data])
              const aEle = document.createElement('a');     // 创建a标签
              const href = window.URL.createObjectURL(blob);       // 创建下载的链接
              aEle.href = href;
              aEle.download = execlName;  // 下载后文件名
              document.body.appendChild(aEle);
              aEle.click();     // 点击下载 
              document.body.removeChild(aEle); // 下载完成移除元素
              window.URL.revokeObjectURL(href) // 释放掉blob对象
            })
          },
          frozenSelectionChange(val) {
            this.frozenSelection = val;
          },
          frozenExcel(){
            this.exportLoading = true;
            let execlName = 'TaskInfo.xlsx';
            const length = this.frozenSelection.length;
            let ids = [];
            for (let i = 0; i < length; i++) {
              ids.push(this.frozenSelection[i].id)
            }
            this.$axios({
              url: `${this.$store.state.islhurl}task/exportFrozenExcel`,
              method: 'post',
              data: {
                ids: ids,
                projectId: this.frozenPaNumber==''?null:this.frozenPaNumber,
                projectName: this.frozenPaName==''?null:this.frozenPaName,
                serviceContractNo: this.frozenContractNo==''?null:this.frozenContractNo,
                taskName: this.frozenTaName==''?null:this.frozenTaName,
                taskNumber: this.frozenTaNumber==''?null:this.frozenTaNumber,
                taskOwner: this.frozenTaOwner==''?null:this.frozenTaOwner,
                taskType: this.frozenTaType==''?null:this.frozenTaType,
                taskStatus: this.frozenTaStatus==''?null:this.frozenTaStatus,
                serviceBom: this.frozenSvBom==''?null:this.frozenSvBom,
                country: this.frozenCountry==''?null:this.frozenCountry,
                deliveryArea: this.frozenDeArea==''?null:this.frozenDeArea,
                taskStartDate: this.frozenTaStartDate==''?null:this.frozenTaStartDate,
                taskEndDate: this.frozenTaEndDate==''?null:this.frozenTaEndDate,
                islhToken : sessionStorage.getItem('islhtoken'),
              },
              responseType:"blob"
            }).then(response=>{
              this.exportLoading = false;
              const blob = new Blob([response.data])
              const aEle = document.createElement('a');     // 创建a标签
              const href = window.URL.createObjectURL(blob);       // 创建下载的链接
              aEle.href = href;
              aEle.download = execlName;  // 下载后文件名
              document.body.appendChild(aEle);
              aEle.click();     // 点击下载 
              document.body.removeChild(aEle); // 下载完成移除元素
              window.URL.revokeObjectURL(href) // 释放掉blob对象
            })
          },
          close(){
            this.$refs.freezeForm.resetFields();
            this.$refs.unFreezeForm.resetFields();
            this.modelFreeze = false;
            this.modelUnFreeze = false;
          },
          advancedFilter(){
            if(this.queryShow){
              this.queryShow = false;
              this.taskType = null;
              this.taskStatus = null;
              this.serviceBom = null;
              this.country = null;
              this.deliveryArea = null;
              this.taskStartDate = null;
              this.taskEndDate = null;
            }else{
              this.queryShow = true;
            }
          },
          frozenFilter(){
            if(this.filterShow){
              this.filterShow = false;
              this.frozenTaType = null;
              this.frozenTaStatus = null;
              this.frozenSvBom = null;
              this.frozenCountry = null;
              this.frozenDeArea = null;
              this.frozenTaStartDate = null;
              this.frozenTaEndDate = null;
            }else{
              this.filterShow = true;
            }
          },
          changePage (val) {
            this.currentPage = val;
            this.getTaskByPage();
          },
          // 改变当前页显示条数
          changePageSize (val) {
            this.pageSize = val;
            this.getTaskByPage();
          },
          changeFrozenPage (val) {
            this.currentFrozenPage = val;
            this.getFrozenTaskList();
          },
          changeFrozenPageSize (val) {
            this.pageFrozenSize = val;
            this.getFrozenTaskList();
          },
          loadMore(n) {
            // n是默认初始展示的条数会在渲染的时候就可以获取,具体可以打log查看
            // elementui下拉超过7条才会出滚动条,如果初始不出滚动条无法触发loadMore方法
            return () => (this.rangeNumber += 5); // 每次滚动到底部可以新增条数,可自定义
          },
          //远程搜索方法
          remoteMethod(list, query) {
            if (query !== '') {
              // 清除之前的定时器
              if (this.timeout) {
                clearTimeout(this.timeout)
              }
              // 防抖处理，300ms后执行
              this.timeout = setTimeout(() => {
                this.fetchUserOptions(list, query)
              }, 200)
            } else {
              this[list] = [];
            }
          },
          fetchUserOptions(list, query) {
            let url =`${this.$store.state.islhurl}user/select-option?keyword=${query}`;
            this._get(url).then().then(res => {
              if(res.code === 200 && res.data) {
                this[list] = res.data;
              } else {
                this[list] = [];
              }
            }).catch(error => {
              this[list] = [];
              console.error('搜索失败:', error)
            })
          },
          remoteBom(query) {
            if (query !== '') {
              setTimeout(() => {
                this.ServiceBomList = this.SBomList.filter(item => {
                  return item.serviceBom.toLowerCase().indexOf(query.toLowerCase()) > -1;
                });
              }, 200);
            } else {
              this.ServiceBomList = this.SBomList;
            }
          },
          remoteFrozenBom(query) {
            if (query !== '') {
              setTimeout(() => {
                this.FrozenBomList = this.SBomList.filter(item => {
                  return item.serviceBom.toLowerCase().indexOf(query.toLowerCase()) > -1;
                });
              }, 200);
            } else {
              this.FrozenBomList = this.SBomList;
            }
          },
        },
        directives:{
          'el-select-loadmore':(el, binding) => {
            // 获取element-ui定义好的scroll盒子
            const SELECTWRAP_DOM = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
            if(SELECTWRAP_DOM){
              //解除绑定事件
              el.unbindEventListener = () => {
                SELECTWRAP_DOM.removeEventListener("scroll", function () {
                  const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
                  if (condition) binding.value();
                });
              }
              //绑定事件
              SELECTWRAP_DOM.addEventListener("scroll", function () {
                /**
                 * scrollHeight 获取元素内容高度(只读)
                 * scrollTop 获取或者设置元素的偏移值,
                 *  常用于:计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
                 * clientHeight 读取元素的可见高度(只读)
                 * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
                 * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
                 */
                const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
                if (condition) binding.value();
              });
            }
          },
        }
    }
</script>



// WEBPACK FOOTER //
// src/view/task/taskList.vue